export default {
  'button.add': '新增',
  'button.edit': '编辑',
  'button.delete': '删除',
  'button.search': '搜索',
  'button.reset': '重置',
  'button.close': '关闭',
  'button.back': '返回',
  'button.submit': '提交',
  'button.resetPassword': '重置密码',
  'button.assignRole': '分配角色',
  'button.dataScope': '数据权限',
  'button.normal': '正常',
  'button.disabled': '禁用',
  'button.enable': '启用',
  'button.directory': '目录',
  'button.menu': '菜单',
  'button.button': '按钮',
  'button.no': '否',
  'button.yes': '是',
  'button.bindGoogle': '绑定谷歌验证器',
  'button.unbindGoogle': '解绑谷歌验证器',
  'button.success': '成功',
  'button.error': '失败',
  'button.detail': '详情',
  'button.logout': '强退',
  'button.generateCode': '生成代码',
  'button.clearData': '清空数据',
  'button.other': '其它',
  'button.onJob': '在职',
  'button.offJob': '离职',
  'button.futures': '合约',
  'button.spot': '现货',
  'button.spotAndFutures': '现货和合约',
  'button.commission': '参与',
  'button.noCommission': '不参与',
  'button.proportion': '比例',
  'button.difference': '级差',
  'button.partner': '合伙人',
  'button.unverified': '未认证',
  'button.realName': '实名认证',
  'button.idCard': '身份证或护照认证',
  'button.video': '视频认证',
  'button.viewInviteChain': '查看邀请链路',
  'button.deleteGa': '删除GA认证',
  'button.all': '全部',
  'button.selfCommission': '自返佣',
  'button.level': '级',
  'button.person': '人',
  'button.copy': '复制',
  'button.copyInviteLink': '复制邀请链接',
  'button.today': '今日',
  'button.yesterday': '昨日',
  'button.lastWeek': '最近7天',
  'button.last30Days': '最近30天',
  'button.thisMonth': '本月',
  'button.lastMonth': '上月',
  'button.last3Months': '最近3个月',
  'button.last6Months': '最近6个月',
  'button.last12Months': '最近12个月',
  'button.chainRecharge': '链上充值',
  'button.chainWithdraw': '链上提现',
  'button.withdrawInternalTransfer': '站内转账',
  'button.withdrawUCard': 'U卡提币',
  'button.uCardWithdraw': 'U卡提现',
  'button.directTransfer': '站内直转',
  'button.level2': '级别',
  'button.unsettled': '待结算',
  'button.settled': '已结算',
  'button.addPartner': '添加合伙人',
  'button.confirmNoCommission': '确认不返佣',
  'button.openLong': '开多',
  'button.openShort': '开空',
  'button.fullPosition': '全仓',
  'button.marginPosition': '逐仓',
  'button.month': '月',
  'button.thisWeek': '本周',
  'button.last15Days': '最近15天',
  'button.view': '查看',
  'button.viewDetail': '查看详情',
  'button.customInviteCode': '自定义邀请码',
  'button.export': '导出',
  'button.confirm': '确认',
  'button.cancel': '取消',
  'button.cancelPartner': '取消合伙人',
  'button.updatePartner': '编辑合伙人',
  'button.upgradePartner': '升级合伙人',
  'button.import': '导入',
};
